import React from "react";
import { connect } from "react-redux";
import { FormSection } from "./forms";

const TransmittalStructureFields = ({
  name,
  selector,
  template,
  templateId,
  fieldRenderer,
  removeStructure
}) => {
  const structureTemplate = template.structure_templates.find(
    st => st.id === templateId
  );

  return (
    <FormSection title={structureTemplate.name} remove={removeStructure}>
      {fieldRenderer(structureTemplate, name)}
    </FormSection>
  );
};

export default connect((state, { name, selector }) => ({
  templateId: selector(state, `${name}.templateId`)
}))(TransmittalStructureFields);



// WEBPACK FOOTER //
// ./src/components/TransmittalStructureFields.js